import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import staticMetaObject from "../../../constants/meta-static-page";
import { useHistory } from "react-router";
import { getCanonicalUrl } from "../../../utils/helpers/get-canonical-url";

const StaticPageMeta = ({type}) => {
    const {location: { pathname = "" }} = useHistory();
    const {title = "", description = "", url = "", metaTitle = ""} = staticMetaObject[type];

    const canonicalUrl = getCanonicalUrl(url || pathname);
    return (
        <Helmet>
            <title>{title}</title>
            {metaTitle && <meta name="title" content={metaTitle} />}
            {description && <meta name="description" content={description} />}
            {canonicalUrl && <link href={canonicalUrl} rel="canonical" />}
        </Helmet>
    );
};

StaticPageMeta.propTypes = {
    type: PropTypes.string
};

export default StaticPageMeta;
